import React, { Component } from "react";

import img_logo from '../img/logo/logo_color.png';
import restaurant_name from '../img/logo/restaurant_name.png';

import icon_maps from '../img/icons/maps.svg';
import icon_phone from '../img/icons/phone.svg';

import logo_insta from '../img/logo/logo-insta.png';
import logo_fb from '../img/logo/logo-fb.png';
import logo_ubereats from '../img/logo/logo-ubereats.png';
import logo_deliveroo from '../img/logo/logo-deliveroo.png';
import logo_justeat from '../img/logo/logo-justeat.png'; 

export default class Footer extends Component {
  render() {
    return (
        <footer>
        
        <div  className="content">
            <img id="contactus" className="logo" src={img_logo} alt="Au petit Bamako"/>
            
            <img className="restaurantName" src={restaurant_name} alt="Au petit Bamako"/>
            <p>Restaurant et traiteur</p>
            <p>Sur place, à emporter, et en livraison</p>
        </div>
        <div className="content">
            <p>Nos horaires</p>
            <p>
            Lundi au Vendredi : 11h30-14h30 puis 19h00-00h00<br/>
            Samedi et Dimanche : 12h00-15h00 puis 19h00-00h00<br/>
            </p>
        </div>
        <div className="content">
            <p>Nous contacter</p>
            <div className="contactWrapper">
                <p>
                    <a href="tel:0950913987">
                        <img src={icon_phone} class="icon"/>
                        09 50 91 39 87
                    </a>
                        <br/>
                    <a href="https://goo.gl/maps/o8NR6oMjia3ze4ah6" target="_blank">
                        <img src={icon_maps} class="icon"/>
                        108 rue de Bagnolet 75020 Paris
                    </a><br/>
                </p>
                <p>
                    <a href="https://instagram.com/aupetitbamako?utm_medium=copy_link" target="_blank"><img className="contact-logo" src={logo_insta}/></a>
                    <a href="https://m.facebook.com/Aupetitbamako/?tsid=0.27024190081107513&source=result" target="_blank"><img className="contact-logo" src={logo_fb}/></a>
                    <a href="https://www.ubereats.com/fr-en/store/au-petit-bamako/7JZA1cFRQmWvLLg7PP3e8A" target="_blank"><img className="contact-logo" src={logo_ubereats}/></a>
                    <a href="https://deliveroo.fr/fr/menu/paris/porte-de-montreuil/lediez" target="_blank"><img className="contact-logo" src={logo_deliveroo}/></a>
                    <a href="https://www.just-eat.fr/menu/au-petit" target="_blank"><img className="contact-logo" src={logo_justeat}/></a>
                </p>
                
            </div>
        </div>
        <div className="content">
            <p>Proverbe africain</p>
            <p>	Le but de notre voyage, de notre quête, est de parvenir à percer le mystère des choses de la vie.</p>
        </div>
    </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js